module.exports = __webpack_public_path__ + "images/logo-blue-120.png";